import {
  activeAllMembersQuery,
  activeCcmQuery,
  activeRpmAndCcmQuery,
  activeRpmQuery,
  disenrolledMembersOrQuery,
} from '../../Common/memberUtils';
import { platformServices } from '../../Common/Values';

const applyCareTeamFilter = (query, showParam) => {
  if (showParam === 'all') {
    return;
  }

  const careTeamOr = [
    { assignedPhysician: showParam },
    { assignedCareManager: showParam },
  ];

  if (query.$and) {
    query.$and.push({ $or: careTeamOr });
  } else if (query.$or) {
    query.$and = [{ $or: query.$or }, { $or: careTeamOr }];
    delete query.$or;
  } else {
    query.$or = careTeamOr;
  }
};

const applyServiceTab = (query, listFilter, serviceTab) => {
  if (listFilter === 'all-members') {
    delete query.disenrolled;
    if (serviceTab === 'rpm') {
      Object.assign(query, activeRpmQuery());
    } else if (serviceTab === 'ccm') {
      Object.assign(query, activeCcmQuery());
    } else if (serviceTab === 'rpm-ccm') {
      Object.assign(query, activeRpmAndCcmQuery());
    } else {
      Object.assign(query, activeAllMembersQuery());
    }
    return;
  }

  if (listFilter === 'disenrolled') {
    if (serviceTab === 'rpm') {
      query.disenrolled = true;
    } else if (serviceTab === 'ccm') {
      query.disenrolledCcm = true;
    } else if (serviceTab === 'rpm-ccm') {
      query.disenrolled = true;
      query.disenrolledCcm = true;
    } else {
      Object.assign(query, disenrolledMembersOrQuery());
    }
  }
};

export const buildMemberListQuery = (
  listFilter,
  showParam,
  serviceTab,
  withServiceTabs,
) => {
  const query = {};

  if (listFilter === 'disenrolled') {
    if (!withServiceTabs) {
      Object.assign(query, disenrolledMembersOrQuery());
    }
  } else if (!withServiceTabs) {
    query.disenrolled = false;
  }

  if (listFilter === 'new-members') {
    query.lastActiveDate = 0;
  } else if (listFilter === 'inactive-2-days') {
    query.lastActiveDate = {
      $lt: Date.now() - 1000 * 60 * 60 * 24 * 2,
    };
  } else if (listFilter === 'inactive-5-days') {
    query.lastActiveDate = {
      $lt: Date.now() - 1000 * 60 * 60 * 24 * 5,
    };
  } else if (listFilter === 'todo-99454') {
    query['billingInsights.CPT99454d'] = { $lt: 16 / 30 };
  } else if (listFilter === 'todo-99457-call') {
    query['billingInsights.CPT99457c'] = false;
  } else if (listFilter === 'todo-99457-review') {
    query['billingInsights.CPT99457a'] = false;
  } else if (listFilter === 'todo-99458-call') {
    query['billingInsights.CPT99457a'] = true;
    query['billingInsights.CPT99457c'] = true;
    query['billingInsights.CPT99458c'] = false;
  } else if (listFilter === 'todo-99458-review') {
    query['billingInsights.CPT99457a'] = true;
    query['billingInsights.CPT99457c'] = true;
    query['billingInsights.CPT99458a'] = false;
  } else if (listFilter === 'msg-unread') {
    query.numUnreadMessages = { $gt: 0 };
  } else if (listFilter === 'missed-call') {
    query.missedCall = { $exists: true };
  } else if (listFilter === 'needs-review') {
    query['warningLog.needsReview'] = true;
  } else if (listFilter.substring(0, 10) === 'Practice: ') {
    query.practiceId = listFilter.substring(10);
  } else if (listFilter === 'with-memo') {
    query['activeMemos.0'] = { $exists: true };
  } else if (listFilter === 'event-today') {
    query['days_till_event'] = 0;
  } else if (listFilter === 'sms-available') {
    query.optInSMS = true;
  } else if (listFilter === 'sms-not-available') {
    query.optInSMS = false;
  } else if (listFilter === 'ccm-members') {
    query.disenrolledCcm = { $ne: true };
    query.services = { $in: [platformServices.CCM] };
    delete query.disenrolled;
  }

  if (withServiceTabs) {
    applyServiceTab(query, listFilter, serviceTab);
  }

  applyCareTeamFilter(query, showParam);
  return query;
};

export const SERVICE_TABS = ['all', 'rpm', 'ccm', 'rpm-ccm'];
